import React, { createContext, useContext, useState } from "react";

const ChartDataContext = createContext();

export const useChartData = () => useContext(ChartDataContext);

export const ChartDataProvider = ({ children }) => {
  const [chartCache, setChartCache] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);

  return (
    <ChartDataContext.Provider
      value={{ chartCache, setChartCache, lastUpdated, setLastUpdated }}
    >
      {children}
    </ChartDataContext.Provider>
  );
};
